<template>
  <div>
    <!-- 搜索框和添加按钮 -->
    <el-row :gutter="20" class="search-and-add-row">
      <el-col :span="6">
        <el-input v-model="searchForm.planName" placeholder="输入培训计划名称" clearable></el-input>
      </el-col>
      <el-col :span="6">
        <el-select v-model="searchForm.organizationId" placeholder="选择机构" clearable style="width: 100%">
          <el-option
              v-for="org in organizations"
              :key="org.id"
              :label="org.name"
              :value="org.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="12" class="search-and-add-buttons">
        <el-button type="primary" @click="fetchData">搜索</el-button>
        <el-button type="primary" @click="showAddPlanDialog" icon="el-icon-plus" style="margin-left: 10px">添加培训计划</el-button>
      </el-col>
    </el-row>

    <!-- 培训计划列表 -->
    <el-table :data="plans" style="width: 100%" stripe>
      <el-table-column label="计划名称" prop="planName" :min-width="200"></el-table-column>
      <el-table-column label="所属机构" prop="organizationId" :min-width="150">
        <template v-slot="{ row }">
          {{ getOrganizationName(row.organizationId) }}
        </template>
      </el-table-column>
      <el-table-column label="开始时间" prop="startDate" :min-width="200">
        <template v-slot="{ row }">
          {{ row.startDate }}
        </template>
      </el-table-column>
      <el-table-column label="结束时间" prop="endDate" :min-width="200">
        <template v-slot="{ row }">
          {{ row.endDate }}
        </template>
      </el-table-column>

      <el-table-column label="操作" :min-width="200">
        <template v-slot="{ row }">
          <el-button type="text" @click="editPlan(row)">编辑</el-button>
          <el-button type="text" @click="deletePlan(row.planId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
        v-if="totalCount > 0"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        layout="total, prev, pager, next, jumper"
        @current-change="handlePageChange"
    ></el-pagination>


    <!-- 添加或编辑培训计划弹框 -->
    <el-dialog v-model="dialogVisible" :title="isEditMode ? '编辑培训计划' : '添加培训计划'">
      <el-form :model="newPlan" label-width="120px" class="form form-container">
        <!-- 计划名称 -->
        <el-form-item label="计划名称">
          <el-input v-model="newPlan.planName" placeholder="请输入计划名称"></el-input>
        </el-form-item>


        <!-- 所属机构（下拉选择框） -->
        <el-form-item label="所属机构" v-if="!isEditMode">
           <el-select v-model="newPlan.organizationId" placeholder="选择机构" clearable style="width: 100%">
              <el-option
                  v-for="org in organizations"
                  :key="org.id"
                  :label="org.name"
                  :value="org.id"
              ></el-option>
            </el-select>
        </el-form-item>
        <!--        v-for="video in (isEditMode ? videoList : newPlan.selectedVideos)"-->
        <el-form-item label="选择视频">
          <el-checkbox-group v-model="newPlan.selectedVideos">
            <el-row :gutter="20">
              <el-col

                  v-for="video   in  videoList "
                  :key="video.id"
                  :span="6"
                  class="video-col"
              >
                <el-checkbox :label="video.id">
                  <div class="video-wrapper">
                    <!-- 使用 video 标签展示视频，并添加点击事件 -->
                    <video :src="video.videoPath" controls class="video" @click="enterFullscreen($event)"></video>
                    <span class="video-name">{{ video.videoName }}</span> <!-- 显示视频名称 -->
                  </div>
                </el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </el-form-item>


        <!-- 开始时间 -->
        <el-form-item label="开始时间">
          <el-date-picker v-model="newPlan.startDate" type="date" placeholder="选择开始时间"></el-date-picker>
        </el-form-item>

        <!-- 结束时间 -->
        <el-form-item label="结束时间">
          <el-date-picker v-model="newPlan.endDate" type="date" placeholder="选择结束时间"></el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="savePlan">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 播放视频弹窗 -->
    <el-dialog v-model="videoDialogVisible" title="视频播放" width="70%">
      <video v-if="currentVideoUrl" :src="currentVideoUrl" controls class="video-player"></video>
      <div slot="footer" class="dialog-footer">
        <el-button @click="videoDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import { ElMessage } from "element-plus";

export default {
  data() {
    return {
      videoList:[],
      organizations: [],
      plans: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 5,
      searchForm: {
        planName: "",
        organizationId: null,
      },
      newPlan: {
        planName: "",
        organizationId: null,
        startDate: "",
        endDate: "",
      },
      dialogVisible: false,
      isEditMode: false,
      editingPlanId: null,
    };
  },
  methods: {
    showAddPlanDialog() {
      this.isEditMode = false; // 切换为添加模式
      this.editingPlanId = null; // 清空编辑计划的 ID
      this.newPlan = {
        planName: "", // 清空计划名称
        organizationId: null, // 清空机构 ID
        startDate: "", // 清空开始时间
        endDate: "", // 清空结束时间
      };
      this.dialogVisible = true; // 打开对话框
    }
,
    fetchData() {
      const params = {
        planName: this.searchForm.planName,
        OrganizationID: this.searchForm.organizationId,
        page: this.currentPage,
        size: this.pageSize,
      };
      axios
          .get("/Manage/plans", { params })
          .then((response) => {
            const { data } = response;
            this.plans = data.data;
            this.totalCount = data.total;
          })
          .catch(() => {
            ElMessage.error("获取数据失败");
          });
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchData();
    },

  getOrganizationName(id) {
    const org = this.organizations.find((o) => o.id === id);
    return org ? org.name : "未知机构";
  },
    savePlan() {
      this.newPlan.ids = this.newPlan.selectedVideos;
      const api = this.isEditMode
          ? `/Manage/plans`
          : "/Manage/plans";
      const method = this.isEditMode ? "put" : "post";
      axios[method](api, this.newPlan)
          .then(() => {
            ElMessage.success(this.isEditMode ? "编辑成功" : "添加成功");
            this.dialogVisible = false;
            this.fetchData();
          })
          .catch(() => {
            ElMessage.error(this.isEditMode ? "编辑失败" : "添加失败");
          });
    },
    editPlan(plan) {
      this.isEditMode = true;
      this.editingPlanId = plan.id;
      this.newPlan = { ...plan };
      this.dialogVisible = true;
    },
    deletePlan(id) {
      this.$confirm("确定删除该计划吗？", "提示", {
        type: "warning",
      })
          .then(() => {
            axios
                .delete(`/Manage/plans/${id}`) // 通过 id 删除
                .then(() => {
                  ElMessage.success("删除成功");
                  this.fetchData(); // 刷新列表数据
                })
                .catch(() => {
                  ElMessage.error("删除失败");
                });
          })
          .catch(() => {
            ElMessage.info("已取消删除"); // 用户取消操作的提示
          });
    }

  },
  created() {
    axios.get("/organization/orglist").then((response) => {
      this.organizations = response.data.data.map((org) => ({
        id: org.organizationID,
        name: org.orgName,
      }));
    });
    axios.get('/videos/all',
        {params:{organizationId:2}}
    )
        .then(res => {
          this.videoList = res.data.data;
        })
        .catch(error => {
          console.error("获取视频列表失败:", error);
        });
    this.fetchData();
  },
};
</script>
<style scoped>
/* 其他样式保持不变 */
</style>

<style scoped>
.el-form-item {
  margin-bottom: 30px; /* 增大表单项之间的间距 */
}

.el-form-item.video-form-item {
  margin-top: 30px;
  margin-bottom: 30px;
}

.video-col {
  display: flex; /* 保证每个视频占据一个列 */
  flex-direction: column;
  align-items: center;
  padding: 10px;
  margin-bottom: 30px; /* 增大上下空隙 */
}

.form-container {
  max-width: 800px;
  margin: 30px auto;
  background: #f9f9f9;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.video-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  margin: 20px; /* 确保每个视频卡片周围都有空隙 */
}

.video-wrapper:hover {
  transform: scale(1.05);
}

.video {
  width: 100%;
  height: auto;
  margin-bottom: 10px; /* 增大视频下方的间隙 */
  border-radius: 5px;
  cursor: pointer; /* 增加鼠标指针变化，表示视频可点击 */
}

.video-name {
  font-size: 14px;
  color: #333;
  text-align: center;
  margin-top: 5px; /* 增大视频名称上方的间隙 */
}
</style>